export const searchInputPlaceholder = () => {
    const blogSearchInputs = document.querySelectorAll('.blog-search .wp-block-search__input');
    const taxonomySearchInputs = document.querySelectorAll('.taxonomy-search .wp-block-search__input');

    if (blogSearchInputs) {
        for (let i = 0; i < blogSearchInputs.length; i++) {
            blogSearchInputs[i].setAttribute("placeholder","Search...");
        }
    }
    if(taxonomySearchInputs){
       for(let i=0; i < taxonomySearchInputs.length; i++){
           taxonomySearchInputs[i].setAttribute("placeholder", "Search by category or key words");
       }
    }
};
